
import { computed, defineComponent, PropType, reactive } from 'vue'

// components
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { OrderInvoiceT } from '@/core/types/orders.types'

// composable
import useAccount from '@/common/composable/useAccount'
import { useRoute, useRouter } from 'vue-router'
import { createToast } from 'mosha-vue-toastify'

// realisations
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: { ButtonDropdown, TheButton },
    props: {
        invoices: {
            type: Array as PropType<OrderInvoiceT[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle-comment', 'print', 'date', 'date-confirm'],
    setup(props, { emit }) {
        const { havePermission, havePermissions } = useAccount()
        const route = useRoute()
        const router = useRouter()
        const order_id = Number(route.params.order_id)

        const state = reactive({
            is_cancelling: false,
        })

        //

        // const emitToggleComment = () => emit('toggle-comment')

        //

        const emitPrintOrder = () => {
            emit('print')
        }

        const emitChangeDate = () => emit('date', order_id)
        const emitConfirmDate = () => emit('date-confirm', order_id)

        const cancelOrder = async () => {
            const answer = confirm(`Вы действительно хотите отменить заказ (id: ${order_id})?`)
            if (!answer) return

            try {
                state.is_cancelling = true

                await orders.cancelOrder(order_id)

                router.replace('/')
            } catch (error) {
                createToast(
                    {
                        title: 'Произошла ошибка при отмене заказа',
                        description: 'Попробуйте ещё раз',
                    },
                    { type: 'danger' }
                )
            } finally {
                state.is_cancelling = false
            }
        }

        // computed

        const isCanEditOrder = computed(() => {
            if (havePermission('all-root-permission')) return true

            if (props.invoices.length && havePermission('order-update-order')) {
                if (props.invoices.some((invoice) => invoice.status_code === 203)) {
                    return false
                } else {
                    return true
                }
            }

            return false
        })

        const isCanCancelOrder = computed(() => {
            if (props.invoices.length > 0) {
                // Тех. поддержка
                if (havePermission('all-root-permission')) return true

                // Создан
                if (
                    props.invoices.every(
                        (invoice) => invoice.status_code === 201 || invoice.status_code === 202
                    )
                ) {
                    return true
                }

                return false
            }

            return false
        })

        const isCanChangeDate = computed(() =>
            havePermissions(['dispatcher.order-take-edit', 'all-root-permission'])
        )
        const isCanConfirmDate = computed(() =>
            havePermissions(['cabinet.shift-take-date-confirmation'])
        )

        // const isCanSendComment = computed(() =>
        //     havePermission('cabinet.send-dispatcher-notification')
        // )

        //

        return {
            state,
            //
            order_id,
            //
            emitPrintOrder,
            cancelOrder,
            // emitToggleComment,
            //
            isCanEditOrder,
            isCanCancelOrder,
            isCanChangeDate,
            isCanConfirmDate,
            emitChangeDate,
            emitConfirmDate,
            // isCanSendComment,
        }
    },
})
